<template>
    <div class="calendar_weekdays">
        <ol class="day-of-week">
            <li
                v-for="weekday in weekdays"
                :key="weekday"
            >
            {{ weekday }}
            </li>
        </ol>
    </div>
</template>

<script>
    const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

    export default {
        name: 'CalendarWeekdays',

        computed: {
            weekdays() {
                return WEEKDAYS
                }
            }
        }
</script>

<style lang="scss" scoped>
    .calendar_weekdays{
        width: 100%;
        height: 100%;
        padding-top: 0.7em;

        ol {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 5%;

            li {
                width: 14.3%;
                display: flex;
                justify-content: center;
                align-items: center;
                font-family:satoshi, $poppins !important;
                font-size: 0.75em;
                color: $dimestDark;
                opacity: 0.7;
            }
        }
    }
</style>